<template>
<div>
    <div class="contentArea">
        <!-- {{showcontent}} -->
        <vs-row>
        <vs-col vs-lg="4" vs-sm="0" vs-xs="0"> </vs-col>
        <vs-col vs-lg="4" vs-sm="6" vs-xs="12" class="flex justify-center">
          <h6>ท่านกำลังเพิ่ม/แก้ไข้ข้อมูลในภาษา {{ radios2.toUpperCase() }}</h6>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
          <vs-row class="flex justify-end">
            <vs-radio
              v-for="(lang, index) in content.language"
              :key="index"
              v-model="radios2"
              class="px-3"
              :vs-value="lang.name"
              @change="changecontent(index)"
              >{{ lang.name.toUpperCase() }}</vs-radio
            >
          </vs-row>
        </vs-col>
      </vs-row>
        
   
    <vs-row vs-w-12>
        <form class="fromstyle">
            <label for="thumbnailpic">รูปปก</label>
            <div v-if="showcontent.banner_img" class="flex justify-content-center"> 
                <img :src="showcontent.banner_img" v-if="showimage_content"  @click="clickimage_content" class="bannerimage">
                <vs-upload v-else limit=1 id="uploadbanner"  automatic  @on-success="successUpload" />
            </div>
            <div v-else>
                <vs-upload limit=1 id="uploadbanner"  automatic  @on-success="successUpload" />
            </div>
            
            <br />
            <label for="header">หัวข้อ</label>
            <vs-input  id="header" class="topicContent" v-model="showcontent.title" />
            <br />
            <label for="header">ลิ้งค์ url</label>
            <vs-input id="header" class="topicContent"  v-model="showcontent.content_link" />
            <br />
            <label for="header">เนื้อหา</label>
            <vs-textarea  height="150px" v-model="showcontent.text" />
            <br />
            <!-- <div v-if="showcontent.sub_content">
                <p v-for="(item,index) in showcontent.sub_content" :key="index">{{item}} </p>

            </div> -->
            <div v-if="showcontent.sub_content && showcontent.sub_content.length > 0" >
                <div v-for="(item, index) in showcontent.sub_content" :key="index">
                    
                    <div class="flex justify-between">
                            <label for="thumbnailpic">รูปปก</label>
                            <vs-icon type="button" icon="delete" size="small" color="#072C49" @click="deletecontent(index)" ></vs-icon>
                    </div>
                    
                    <div v-if="item.sub_content_img" class="flex justify-content-center">
                        
                        <img :src="item.sub_content_img" v-if="showimage_subcontent[index]" @click="clickimage_subcontent(index)" class="bannerimage">
                        <vs-upload v-else limit=1 id="uploadbanner"  automatic  @on-success="successUpload" />
                        
                    </div>
                    <div v-else>
                        <vs-upload limit=1 id="uploadbanner"  automatic  @on-success="successUpload" />
                    </div>                   
                    <br />
                    <label for="header">เนื้อหา</label>
                    <vs-textarea  height="150px" v-model="item.text" />
                
                </div>
            </div>
            <button type="button" class="addcontent-btn" @click="addcontent">+ เพิ่มรายระเอียด</button>
            
            
        </form>
         <vs-col vs-w="12" class="flex justify-end">
            <button class="share-btn" :@click="summitForm">เผยแพร่</button>
         </vs-col>
    </vs-row>
        
    </div>

</div>
   
</template>

<script>
import {mapGetters} from "vuex";
import Delete from '../ag-grid-table/table_component/Delete.vue';
export default {
  
    mounted(){
        this.$store.dispatch("general/get_content")
      
            for (let [key, value] of Object.entries(this.content)){
                // console.log("key",key)
                // console.log("radio",this.radios2)
                
                if (key===this.radios2){
                    this.showcontent = value
                }
            }

            console.log("showcontent",this.showcontent);
        
        this.$store.dispatch("general/push_isShow",this.showcontent);  
            

            
        
       
    },
    
    
    methods: {
        deletecontent(index){
            this.$store.dispatch("general/delete_content",{lang:this.radios2,index:index})
        },
        clickimage_content(){
            this.showimage_content = !this.showimage_content
        },
        clickimage_subcontent(index){
            console.log("clicked");
            this.showimage_subcontent.splice(index,1,!this.showimage_subcontent[index])
            console.log(this.showimage_subcontent);
        },
        addcontent(){
            // console.log("!!!!!",this.radios2);
            this.$store.dispatch("general/push_content",this.radios2)
            
            // this.$store.dispatch("general/push_cat","cat")
            // console.log("items",items)
        },
        changecontent(index){
            // this.$store.commit("general/GET_CONTENT")
           this.$store.dispatch("general/change_content",index)
           
            for (let [key, value] of Object.entries(this.content)){
                // console.log("key",key)
                // console.log("radio",this.radios2)

                if (key===this.radios2){
                    this.showcontent = value
                }
            }

            //this.$store.dispatch("general/push_isShow",this.showcontent); 
            // console.log("length",this.showcontent.sub_content.length);
            
            let length = this.showcontent.sub_content.length
            let countimage = []
            this.showimage_subcontent= []
            for (let i=0; i<length ;i++){
                countimage.push(true)
            }
            this.showimage_subcontent=[...countimage]
           
            console.log(this.showimage_subcontent)
        },

        successUpload(){
        this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
    },  
    },
    data() {
        return {
            inputtopic:"",
            inputurl:"",
            textarea:"",
            radios2:"th",
            showcontent:"",
            showimage_content:true,
            showimage_subcontent:[]
            
        }

    },
    computed: {
        ...mapGetters({
            content: "general/content",
            a:"general/a"
          
        })

    },
};
</script>


<style lang="scss" scoped>


    .contentArea{
        border-style: solid;
        border-width: 2px;
        border-color: rgb(92, 92, 92);
        padding: 30px 20px;
        
        margin-top:100px;
        justify-content: center;
        border-radius: 5px;
    }
    .topicContent{
        width: 100%;
    }
    .fromstyle{
        width: 100%;
    }
    .share-btn {
    margin-top: 20px;
    background-color: gray;
    padding: 5px 40px 5px 40px;
    border-radius: 10px;
    border-style: none;
    color: #ffff;
    }
    .share-btn:hover {
    transition-delay: 100ms;
    background-color: #072C49;
    }
    .share-btn:active {
    background-color: #072C49;
    }
    .addcontent-btn{
        width: 100%;
        padding: 5px 40px 5px 40px;
        border-style: none;
        color: #ffff;
        background-color: #072C49;
    }
    .imagebox{
       background-color: pink;
       width: 100%;
    }
    .bannerimage {
    height: 250px;
    max-width: 100%;
    }

   
</style>

